import { MenuItem } from '../models/menu/menu.model';
import { ROUTE_IDENTIFIER_NAMES } from '../models/route-identifiers/route-identifiers.model';
import { SECURITY_ROLE_KEY } from '../models/security/security-role-keys';

export const demoMenu: MenuItem[] = [
  {
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN,
    securityRoles: SECURITY_ROLE_KEY.JobRolePeople,
    subMenu: [
      {
        label: 'Notification settings',
        route: '/notifications',
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_NOTIFICATION_SETTINGS,
        hideItem: false,
      },
    ],
  },
  {
    label: 'Training management',
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.LMS,
    securityRoles: SECURITY_ROLE_KEY.Superuser,
    hideItem: true,
  },
];
